function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-294 -568)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  transform: "translate(216 532)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cover"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-products-GAP-/-16-/-Automobile",
  transform: "translate(76 32)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.35 16.8a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM7.197 11.2l1.314-3.517C8.664 7.274 9.06 7 9.495 7h9.01c.436 0 .831.274.984.683l1.314 3.517H7.197zm-.547 5.6a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zm16.429-5.508l-1.623-4.345a3.164 3.164 0 00-2.95-2.047H9.494a3.164 3.164 0 00-2.95 2.047L4.92 11.293A2.795 2.795 0 002.8 14v6.3h2.1v1.75a1.75 1.75 0 103.5 0V20.3h11.2v1.75a1.75 1.75 0 103.5 0V20.3h2.1V14a2.794 2.794 0 00-2.121-2.708z",
  id: "Automobile"
}))))))));